<template lang="pug">
v-card.fill-height.sdo-radius
  v-alert(
    color="error darken-2"
    flat
    text
    dark
  ).sdo-radius.pa-10.ma-0
    .mb-8
      h1(v-if="isRequestRejected") Ваша заявка отклонена
      h1(v-else) Вы отчислены
      .caption Текущий статус
    p(v-if="!isRequestRejected")
      |  К сожалению, вы были отчислены с курса. Если сохраняется желание освоить материал,
      |  Вы можете подать заявку в другой набор
    p(v-else)
      | Ваша заявка была отклонена, Вы можете подать заявку в другой набор
    div(v-if="course.priority_user_prior_record.user_record.reason")
      strong Причина: «{{ course.priority_user_prior_record.user_record.reason }}»
    slot(name="slot" color="error")
</template>

<script>
export default {
  props: {
    course: { type: Object, required: true },
  },
  computed: {
    isRequestRejected() {
      return !this.course.priority_user_prior_record.user_record.group;
    },
  },
};
</script>
